// extracted by mini-css-extract-plugin
export default {"component":"page_component__jj44H","auth":"page_auth__VcGcY"};